module.exports = __webpack_public_path__ + "img/logo1.f37a2078.png";